import { createAuthClient } from "better-auth/react";
import { stripeClient } from "@better-auth/stripe/client";

export const authClient = createAuthClient({
  // No baseURL — uses same-origin requests in production.
  // In dev, Vite proxy or CORS handles cross-origin to the Worker.
  plugins: [stripeClient({ subscription: true })],
});

export const { signIn, signUp, signOut, useSession } = authClient;
